import { Component, inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { AuthContextService } from '@core/auth/context/auth-context.service';
import { toSafeInternalUri } from '@core/auth/safe-internal-uri';
import { LogRocketService } from '@core/observability/logrocket/logrocket.service';
import { engagementIdFromConnectPath } from '@core/observability/logrocket/logrocket.events';

@Component({
  selector: 'app-okta-callback-wrapper',
  template: ``,
})
export class OktaCallbackWrapperComponent {
  private readonly oktaAuth = inject(OKTA_AUTH);
  private readonly authContext = inject(AuthContextService);
  private readonly logRocket = inject(LogRocketService);

  constructor() {
    void this.handleLoginRedirect();
  }

  private async handleLoginRedirect(): Promise<void> {
    try {
      await this.oktaAuth.handleLoginRedirect();
      this.authContext.setAuthType('internal');
      const destination = toSafeInternalUri(this.oktaAuth.getOriginalUri());
      this.logRocket.markFreshLogin(engagementIdFromConnectPath(destination));
    } catch {
      // redirect errors are handled by Okta SDK
    }
  }
}
